export default __webpack_public_path__ + "static/post_3-fb13a86a4d1fd9932c9cba8eb70c2534.png";